import React from 'react';
import useAuthForm from '../../../hooks/useAuthForm';
import { signup } from '../../../services/authService';
import validateByType from '../../../hooks/useFormValidation';

const useRegister = () => {
  const formInstance = useAuthForm({
    initialValues: {
      email: '',
      password: '',
      phone: '',
      password_confirmation: '',
      sector: '',
      country_code: '',
      referral_code: '',
    },
    validateFn: (form) => validateByType('register', form),
    submitFn: signup,
    onSuccessNavigateTo: '/verify-email',
    initialStep: 1,
  });

  const onCountryCodeChange = (e) => {
    formInstance.onChange({
      target: { name: 'country_code', value: e.target.value }
    });
  };

  return {
    ...formInstance,
    onCountryCodeChange
  };
};

export default useRegister;
